/**
 * Mixin notyfikacji
 * Zawiera metody:
 *  - `notifySuccess(message)` - wyświetla powiadomienie o sukcesie
 *  - `notifyError(message)` - wyświetla powiadomienie o błędzie
 */
export const notificationsMixin = {
  methods: {
    /**
     * Wyświetla notyfikację o sukcesie
     *
     * @param {string} title
     * @param {string} messages
     */
    notifySuccess(title: string, messages: string) {
      (this as any).$store.dispatch('notifySuccess', { title, messages });
    },

    /**
     * Wyświetla notyfikację o błędzie
     *
     * @param {string} title
     * @param {string} messages
     */
    notifyError(title: string, messages: string) {
      (this as any).$store.dispatch('notifyError', { title, messages });
    }
  }
};
